import React from 'react';
import { Instagram } from 'lucide-react';

export const SponsorBanner = ({ language = 'pt' }) => {
  return (
    <div className="py-6 px-4 sm:px-6 lg:px-8 bg-brown-900">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <p className="text-white text-base sm:text-lg font-bold text-center sm:text-left">
            {language === 'pt' 
              ? 'Nossos ocicats usam alimentação de alta qualidade: Fórmula Natural'
              : 'Our ocicats use high quality nutrition: Fórmula Natural'}
          </p>
          
          <div className="flex flex-col items-center gap-3">
            {/* Logo com Link */}
            <div className="flex-shrink-0">
              <a
                href="https://www.formulanatural.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                className="block hover:opacity-80 transition-opacity"
              >
                <img
                  loading="lazy" decoding="async" src="https://customer-assets.emergentagent.com/job_pedigree-cats/artifacts/6105zmyl_Logo%20%20Fo%CC%81rugla%20Natural_AZUL_SLOGAN_NOVO.png"
                  alt="Fórmula Natural"
                  className="h-28 sm:h-[115px] w-auto"
                />
              </a>
            </div>

            {/* Instagram Link - Abaixo do Logo */}
            <a
              href="https://www.instagram.com/formulanaturaloficial/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-white hover:text-gray-200 transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span className="text-sm font-medium whitespace-nowrap">
                {language === 'pt' ? 'Instagram Oficial' : 'Official Instagram'}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};